export const sortData = (data, idProp = 'id', nameProp = 'name', parentProp = 'parent_Id') => {
	const getSegment = (data, parent, level) => {
		return data.reduce((c, d) => {
			let nc = [...c];
			if (d[parentProp] === parent || (parent === 0 && !d[parentProp])) {
				d.level = level;
				nc.push(d);
				const children = getSegment(data, d[idProp], level + 1);
				if (children.length > 0) {
					d.children = true;
					nc = nc.concat(children);
				}
			}
			return nc;
		}, []);
	};

	const compare = (a, b) => {
		if ((a[nameProp] || '').toLowerCase() < (b[nameProp] || '').toLowerCase()) return -1;
		if ((a[nameProp] || '').toLowerCase() > (b[nameProp] || '').toLowerCase()) return 1;
		return 0;
	};

	if (parentProp) {
		return getSegment(data.sort(compare), 0, 0);
	} else {
		return data.sort(compare);
	}
};
